'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as a happy emoji with default color.
 */
export function EarphoneMusicEmojiAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('../raw-json/emojis/earphone-music-emoji.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="EarphoneMusicEmojiAnimation"
    />
  );
}
